module.exports = __webpack_public_path__ + "static/media/icon-noise.e7233c75.svg";